import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"

import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

/**
 * Reusable status badge component with icon and label
 *
 * @param {string} icon - FontAwesome5 icon name
 * @param {string} label - Text to display
 * @param {string} color - Text and icon color
 * @param {string} backgroundColor - Badge background color
 * @param {number} fontSize - Font size (default: 10)
 * @param {number} iconSize - Icon size (default: 10)
 * @param {object} style - Additional container styles
 */
const StatusBadgeM = ({
    icon,
    label,
    color = theme.colors.grey,
    backgroundColor = theme.colors.lighter,
    fontSize = 10,
    iconSize = 10,
    style,
}) => {
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor,
                paddingHorizontal: 8,
                paddingVertical: 4,
                borderRadius: 12,
                ...style,
            }}
        >
            {icon && (
                <FontAwesome5
                    name={icon}
                    size={iconSize}
                    color={color}
                    style={{ marginRight: 4 }}
                />
            )}
            <TextM fontSize={fontSize} fontWeight="SemiBold" color={color}>
                {label}
            </TextM>
        </View>
    )
}

export default StatusBadgeM
